<template>
  <div
    v-if="initdisplay"
    id="bookmarkSelector"
  >
    <v-speed-dial
      v-model="unfolded"
      class="speed-dial"
      :direction="$mq | mq({
        mobile: 'left',
        tablet: 'left',
        desktop: 'top',
      })"
      scale
    >
      <template v-slot:activator>
        <v-btn
          v-model="unfolded"
          class="control"
          fab
          small
          style="width: 3em;"
        >
          <v-icon
            v-if="unfolded"
          >
            mdi-close
          </v-icon>
          <v-icon
            v-else
          >
            mdi-book-outline mdi-24px
          </v-icon>
        </v-btn>
      </template>
      <div
        style="width:auto;"
        :style="$mq | mq({
          mobile: 'margin-right: 0.5em',
          tablet: 'margin-right: 0.5em',
          desktop: 'margin-right: 5em',
        })"
      >
        <v-btn
          v-for="(bookmark,i) in bookmarks"
          :key="i"
          class="bookmark"
          :color="baseColorAccent"
          style="fontWeight:600;"
          elevation="10"
          block
          @click="gotoBookmark(bookmark)"
        >
          <div :style="{color:iconColor}">
            {{ bookmark.name }}
          </div>
        </v-btn>
      </div>
    </v-speed-dial>
  </div>
</template>

<script>

import { EventBus } from '../../event-bus';

export default {
  name: 'Bookmarks',
  data() {
    return {
      bookmarks: this.$appConfig.bookmarks,
      initdisplay: this.$appConfig.bookmarkSelector,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      unfolded: false,
    };
  },
  computed: {
  },
  mounted() {
    EventBus.$on('showingFloors', () => {
      this.unfolded = false;
    });
  },
  methods: {
    gotoBookmark(bookmark) {
      // EventBus.$emit('panLLZ', bookmark.position.lat, bookmark.position.lon, bookmark.position.zoom);
      EventBus.$emit('draw-and-goto-marker', bookmark.position.lat, bookmark.position.lon);
    },
  },
};

</script>

<style scoped>
.control {
  border-radius:10px;
  margin: 0.25em;
}
</style>
